import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=5db81af9&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=5db81af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db81af9",
  null
  
)

export default component.exports